namespace TabAurous.Production {
    export interface IssueMaterialItemsRow {
        TransItemId?: number;
        TransDetailId?: number;
        BagNo?: string;
        SubBagNo?: number;
        LotNo?: string;
        OldBagNo?: string;
        Line_No?: number;
        OldLineNo?: number;
        DepartmentId?: number;
        StockDepartmentId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductTypeId?: number;
        KaratId?: number;
        MetalColorId?: number;
        HSN?: string;
        TaxCode?: string;
        SKU?: string;
        AttributeId?: number;
        Attribute?: string;
        ItemTypeId?: number;
        Pieces?: number;
        Weight?: number;
        CalcOnId?: number;
        NetWeight?: number;
        Purity?: number;
        PureWeight?: number;
        Rate?: number;
        Amount?: number;
        ParentMetalId?: number;
        ParentAttributeId?: number;
        DeliveryDate?: string;
        RefTransId?: number;
        RefTransItemId?: number;
        RefVoucherId?: number;
        SettingId?: number;
        SettingName?: string;
        StoneStatusId?: number;
        StoneStatusName?: string;
        Lab?: string;
        CertificateNo?: string;
        StockAllocation?: boolean;
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        OrderPieces?: number;
        OrderWeight?: number;
        KaratName?: string;
        MetalColorName?: string;
        StoneSizeName?: string;
        ShapeName?: string;
        SieveName?: string;
        QualityName?: string;
        StoneColoreName?: string;
        ShapeCode?: string;
        SieveCode?: string;
        QualityCode?: string;
        StoneSizeCode?: string;
        StoneColorCode?: string;
    }

    export namespace IssueMaterialItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.IssueMaterialItems';
        export const lookupKey = 'Production.IssueMaterialItems';

        export function getLookup(): Q.Lookup<IssueMaterialItemsRow> {
            return Q.getLookup<IssueMaterialItemsRow>('Production.IssueMaterialItems');
        }
        export const deletePermission = 'Production:IssueMaterial:Delete';
        export const insertPermission = 'Production:IssueMaterial:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:IssueMaterial:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransDetailId = "TransDetailId",
            BagNo = "BagNo",
            SubBagNo = "SubBagNo",
            LotNo = "LotNo",
            OldBagNo = "OldBagNo",
            Line_No = "Line_No",
            OldLineNo = "OldLineNo",
            DepartmentId = "DepartmentId",
            StockDepartmentId = "StockDepartmentId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductTypeId = "ProductTypeId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            HSN = "HSN",
            TaxCode = "TaxCode",
            SKU = "SKU",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            ItemTypeId = "ItemTypeId",
            Pieces = "Pieces",
            Weight = "Weight",
            CalcOnId = "CalcOnId",
            NetWeight = "NetWeight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            Rate = "Rate",
            Amount = "Amount",
            ParentMetalId = "ParentMetalId",
            ParentAttributeId = "ParentAttributeId",
            DeliveryDate = "DeliveryDate",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefVoucherId = "RefVoucherId",
            SettingId = "SettingId",
            SettingName = "SettingName",
            StoneStatusId = "StoneStatusId",
            StoneStatusName = "StoneStatusName",
            Lab = "Lab",
            CertificateNo = "CertificateNo",
            StockAllocation = "StockAllocation",
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            OrderPieces = "OrderPieces",
            OrderWeight = "OrderWeight",
            KaratName = "KaratName",
            MetalColorName = "MetalColorName",
            StoneSizeName = "StoneSizeName",
            ShapeName = "ShapeName",
            SieveName = "SieveName",
            QualityName = "QualityName",
            StoneColoreName = "StoneColoreName",
            ShapeCode = "ShapeCode",
            SieveCode = "SieveCode",
            QualityCode = "QualityCode",
            StoneSizeCode = "StoneSizeCode",
            StoneColorCode = "StoneColorCode"
        }
    }
}
